import React, { useState, useEffect } from 'react';

const Countdown = ({ start, end }) => {
  const startDate = new Date(start);
  const targetDate = new Date(end);
  const currentDate = new Date();
  const translations = {
    en: { days: 'DAYS', hours: 'HOURS', minutes: 'MIN', seconds: 'SEC' },
    it: { days: 'GIORNI', hours: 'ORE', minutes: 'MIN', seconds: 'SEC' },
    es: { days: 'DÍAS', hours: 'HRS', minutes: 'MIN', seconds: 'SEG' },
  };
  const locale = window.freedomeConfig?.locale || 'en';
  const labels = translations[locale];
  const [timeRemaining, setTimeRemaining] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  const calculateTimeRemaining = () => {
    const currentDate = new Date();
    const totalDuration = targetDate - startDate;
    const elapsedTime = currentDate - startDate;

    if (elapsedTime >= totalDuration) {
      return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }

    const remainingTime = totalDuration - elapsedTime;

    const days = Math.floor(remainingTime / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor(
      (remainingTime % (1000 * 60 * 60)) / (1000 * 60)
    );
    const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);

    return { days, hours, minutes, seconds };
  };

  useEffect(() => {
    setTimeRemaining(calculateTimeRemaining());
    const intervalId = setInterval(() => {
      setTimeRemaining(calculateTimeRemaining());
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  const formatTime = (time) => String(time).padStart(2, '0');

  if (!start || !end || currentDate < startDate || targetDate < startDate) {
    return '';
  }

  return (
    <div>
      {timeRemaining.days} {labels.days} {formatTime(timeRemaining.hours)}{' '}
      {labels.hours} {formatTime(timeRemaining.minutes)} {labels.minutes}{' '}
      {formatTime(timeRemaining.seconds)} {labels.seconds}
    </div>
  );
};

export default Countdown;
